import dynamic from "next/dynamic";

import LazyLoadArticleList from "components/lazyLoadArticleList/lazyLoadArticleList";
import AuthorHero from "./components/authorHero";

const CalloutContainer = dynamic(
  () => import("components/inHouseAdCallout/calloutContainer/calloutContainer"),
  {
    ssr: false,
  }
);

const AuthorView = ({ data }) => {
  const {
    name,
    bio,
    image,
    socials,
  }: {
    name: string;
    bio: string;
    image: string;
    socials: {
      twitter?: string;
      signal?: string;
      email?: string;
      linkedin?: string;
    };
  } = data?.authorData?.author;

  const newsLetterAuthors = {
    "Freya Pratty": "climatetech",
    "Amy O'Brien": "fintech",
    "Miriam Partington": "startuplife",
    "Anisah Osman Britton": "startuplife",
    "Amy Lewin": "upround",
    "Eleanor Warnock": "upround",
    "Sadia Nowshin": "sifted",
    "Tom Nugent": "sifted",
  };

  const authorNames = Array.from(Object.keys(newsLetterAuthors));
  const isNewsLetterAuthor = !!authorNames.includes(name);

  return (
    <main className="pt-[60px] text-black-rock lg:pt-[69px]">
      <div className="mb-6 md:mb-[12px]">
        <AuthorHero bio={bio} image={image} name={name} socials={socials} />
      </div>

      <div className="wrapper relative overflow-hidden">
        <div className="max-w-[940px] pb-3xl md:mx-auto md:pb-4xl lg:w-10/12">
          {isNewsLetterAuthor && (
            <div className="mb-6 mt-[12px] md:my-[52px] md:mt-[40px]">
              <CalloutContainer staticType={newsLetterAuthors[name]} />
            </div>
          )}

          <div className="mb-[16px] md:mb-[52px]">
            <LazyLoadArticleList
              query={data.query}
              data={data.articles}
              withPills={false}
            />
          </div>
        </div>
      </div>
    </main>
  );
};

export default AuthorView;
